import instantReqTypes, { isntantReqSteps } from "./instantReq.types";

const INITIAL_STATE = {
  step: isntantReqSteps.waiting,

  reqStatus: "",
  reqStatusIsloading: false,

  showingStatus: [],

  newInstantReqResult: null,
};
const instantReqReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case instantReqTypes.RESPONSE_NEW_INSTANT_REQUEST_RESULT:
      return {
        ...state,
        newInstantReqResult: action.payload,
      };
    case instantReqTypes.SET_STEP:
      return {
        ...state,
        step: action.payload,
      };
    case instantReqTypes.FETCH_STATUS_START:
      return {
        ...state,
        reqStatusIsloading: true,
      };
    case instantReqTypes.FETCH_STATUS_SUCCESS:
      return {
        ...state,
        reqStatus: action.payload,
        reqStatusIsloading: false,
      };
    case instantReqTypes.SET_STATUS_SHOWING:
      const arr = [...state.showingStatus];
      arr.unshift({ ...action.payload });
      return {
        ...state,
        showingStatus: arr,
      };
    case instantReqTypes.CLEAR_STATUS_SHOWING:
      return {
        ...state,
        showingStatus: [],
      };
    default:
      return state;
  }
};

export default instantReqReducer;
